var camelCase = require('lodash.camelcase');
function snakeCase(str) {
  var camel = camelCase(str);
  var snake = camel.replace(/[A-Z]/g, function (match) {
    return "_".concat(match.toLowerCase());
  });
  return snake;
}
module.exports = {
  snakeCase: snakeCase
};